<template>
  <div id="app">
    <router-view class="page"></router-view>
  </div>
</template>

<script>
export default {
  name: "RootView",
  components: {},
  created() {},
  watch: {
    $route: {
      handler: function (to, from) {
        this.$store.commit("SET_CURRENTROUTER", to.path);
      },
      deep: true,
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy(){
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    handleBeforeUnload(event) {
      this.$tencentChat.loginOut();
      this.$tencentChat.destruct();
      localStorage.setItem('hasRefreshed', 0);
    },
    handleUnload() {
      console.log('页面已关闭或刷新');
    }
  }
};
</script>
<style>
html,
#app,
.page {
  width: 100%;
  height: 100%;
}
/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 5px; /* 滚动条宽度 */
}

/* 滚动条轨道样式 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道背景颜色 */
  border-radius: 6px; /* 轨道圆角 */
}

/* 滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background: #d6d6d6; /* 滑块背景颜色 */
  border-radius: 6px; /* 滑块圆角 */
}

/* 鼠标悬停在滑块上时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #b1b1b1; /* 悬停时滑块背景颜色 */
}
.body {
  height: calc(100vh - 76px);
}
</style>
